import Chip from '@mui/material/Chip';
import type { RaRecord } from 'react-admin';
import { useRecordContext } from 'react-admin';

type StatusChipFieldProps = {
    source: string;
    label?: string;
};

type ChipTone = 'default' | 'success' | 'warning' | 'error' | 'info';

function toStatusLabel(value: unknown): string {
    const rawValue = String(value ?? '').trim();
    if (!rawValue) return 'Unspecified';
    return rawValue;
}

function getChipTone(status: string): ChipTone {
    const normalized = status.trim().toLowerCase();

    if (!normalized) return 'default';
    if (['done', 'completed', 'complete', 'closed', 'resolved'].includes(normalized)) return 'success';
    if (['in progress', 'in-progress', 'processing', 'working', 'ongoing'].includes(normalized)) return 'info';
    if (['pending', 'todo', 'to do', 'new', 'open', 'unread'].includes(normalized)) return 'warning';
    if (['blocked', 'failed', 'rejected', 'spam', 'urgent', 'escalated'].includes(normalized)) return 'error';

    return 'default';
}

export function StatusChipField(props: StatusChipFieldProps) {
    const record = useRecordContext<RaRecord>(props);
    const status = toStatusLabel(record?.[props.source]);

    return <Chip label={status} color={getChipTone(status)} size="small" variant="outlined" />;
}